import users from './users';
import essentials from './essentials';
import configs from './configs';
import config from './config';
import policies from './policies';
import program from './program';
import programs from './programs';
import task from './task';
import provider from './provider';
import patient from './patient';
import reporting from './reporting';
// TODO: To phase out
import careteams from './careteams';
import skuLowStockThreshold from './skuLowStockThreshold';
import consumableSales from './consumableSales';
import orgs from './orgs';
import countries from './countries';
import nationalities from './nationalities';
import genders from './genders';
import chargeitemcodes from './chargeitemcodes';
import audittrail from './audittrail';
import billing from './billing';
import inventory from './inventory';
import patients from './patients';
import versions from './versions';
import changeRequest from './changeRequest';
import contractNo from './contractNo';
import monit from './monit';
import contracts from './contracts';
import sku from './sku';
import devices from './devices';
import currencies from './currencies';
import feedbacks from './feedbacks';
import feedbackResponse from './feedbackResponse';
import questionnaires from './questionnaires';
import taskObservation from './taskObservation';
import report from './report';
import problems from './problems';
import adt from './adt';
import adtSurvey from './adtSurvey';
import adherenceReport from './adherenceReport';
import notes from './notes';

export default {
    users,
    essentials,
    configs,
    config,
    policies,
    program,
    programs,
    task,
    provider,
    patient,
    careteams,
    skuLowStockThreshold,
    consumableSales,
    orgs,
    countries,
    nationalities,
    genders,
    chargeitemcodes,
    audittrail,
    billing,
    inventory,
    patients,
    versions,
    changeRequest,
    contractNo,
    monit,
    contracts,
    sku,
    devices,
    currencies,
    feedbacks,
    feedbackResponse,
    questionnaires,
    taskObservation,
    problems,
    adt,
    adtSurvey,
    adherenceReport,
    report,
    reporting,
    notes
};